module.exports = __webpack_public_path__ + "static/img/1-2.4ad70cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/1-2.png
// module id = 6dg9
// module chunks = 0